module.exports = __webpack_public_path__ + "img/icons B_14.ac0cc4d1.png";